import React, { useEffect, useState, useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import {
  Select,
  Typography,
  Space,
  Button,
  Table,
  Modal,
  Form,
  Input,
  notification,
  Upload,
  message,
  Card,
  DatePicker,
  Row,
  Col,
} from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import contentServiceApi from "../../service/contentService";
import translateApi from "../../service/translateService";
import {
  EditorState,
  ContentState,
  convertFromHTML,
} from "draft-js";
import "./management.css";
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';

const { Option } = Select;
export default function ManagementPage() {
  const [contentId, setContentId] = useState(0);

  const [isShowUpdateService, setIsShowUpdateService] = useState(false);

  const [listContentService, setListContentService] = useState([]);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [formContent] = Form.useForm();
  
  const [dataChange, setDataChange] = useState(true);

  const [language, setLanguage] = useState("vi");
  const [loadingTranslate, setLoadingTranslate] = useState(false);
  const [dataTranslate, setDataTranslate] = useState();

  useEffect(() => {
    getAllContents();
  }, []);

  const onFormValueChange = () =>{
    setDataChange(true)
  }

  const getAllContents = () => {
    contentServiceApi.getAll().then((res) => {
      setListContentService(res.data);
    });
  };

  const deleteContent = () => {
    contentServiceApi.deleteContentById(contentId).then((res) => {
      notification.success({ message: `Xóa Thành Công` });
      getAllContents();
      setOpenDeleteDialog(false);
      setContentId(0);
    });
  };

  const openModalService = (id) => {
    setContentId(id);
    if (id) {
      contentServiceApi.getById(id).then((res) => {
        formContent.setFieldsValue({
          title: res.data.title,
          slug: res.data.slug,
          content: res.data.content,
        });
        setIsShowUpdateService(true);
      });
    }
  };

  const onCloseModalContent = () => {
    setIsShowUpdateService(false);
    setLanguage("vi");
    formContent.setFieldsValue({
      title: "",
      slug: "",
      content: "",
    });
  };

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 20 },
  };

  const openDeleteService = (id) => {
    setContentId(id);
    setOpenDeleteDialog(true);
  };
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex, placeHolderSearch) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Tìm kiếm ${placeHolderSearch}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Tìm kiếm
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Đặt lại
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Lọc
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
    get(record, dataIndex)
    .toString()
    .toLowerCase()
    .includes(value.toLowerCase()),
      // record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
    isEqual(searchedColumn, dataIndex) ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text?.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columnsService = [
    {
      title: "Tiêu Đề",
      dataIndex: "title",
      key: "title",
      ...getColumnSearchProps("title", "tiêu đề"),
    },
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
      ...getColumnSearchProps("slug", "Slug"),
    },
    {
      title: "Nội dung",
      dataIndex: "content",
      key: "content",
    },
    {
      title: "Action",
      key: "action",
      width: "180px",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openModalService(_.id)}
          >
            Sửa
          </Button>
          <Button
            type="danger"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openDeleteService(_.id)}
          >
            Xóa
          </Button>
        </Space>
      ),
    },
  ];

  const onFinishHandleEvent = (values) => {
    if (contentId !== 0) {
      if (language !== "vi") {
        let newData = {};
        newData[language] = {
          title: formContent.getFieldValue("title"),
          content: formContent.getFieldValue("content"),
        }
        values = { textTranslate: JSON.stringify(newData) };
      }
      contentServiceApi.updateContent(contentId, values).then((res) => {
        notification.success({ message: "Sửa Nội Dung Thành Công" });
        getAllContents();
        onCloseModalContent();
        setContentId(0);
      });
    } else {
      contentServiceApi.createContent(values).then((res) => {
        notification.success({ message: "Tạo Nội Dung Thành Công" });
        formContent.setFieldsValue({
          title: "",
          slug: "",
          content: "",
        });
        getAllContents();
        onCloseModalContent();
      });
    }
  };

  const onSelectLanguage = (value) => {
    onHandleTranslate(contentId, value);
    setLanguage(value);
  };

  const onHandleTranslate = (id, forceLang) => {
    setLoadingTranslate(true);
    const textData = {
      title: formContent.getFieldValue('title'),
      content: formContent.getFieldValue('content'),
    };
    const data = {
      text: textData,
      language: forceLang ? forceLang : language,
      type: "content",
      id: id,
    };

    translateApi.translate(data).then((res) => {
      const textTranslate = res.data;
      setLoadingTranslate(false);
      formContent.setFieldsValue({
        title: textTranslate.title,
        content: textTranslate.content,
      });
    });
  };

  return (
    <>
      <Card
        title={
          <Typography style={{ textAlign: "center" }}>
            Nội Dung
          </Typography>
        }
        extra={
          <Button
            type="primary"
            style={{
              borderRadius: "8px",
            }}
            onClick={() => {
              setIsShowUpdateService(true);
            }}
          >
            Tạo nội dung
          </Button>
        }
      >
        <Table
          columns={columnsService}
          dataSource={listContentService}
          bordered
        />

        <Modal
          title={
            contentId !== 0
              ? "Cập Nhật nội dung"
              : "Tạo nội dung"
          }
          visible={isShowUpdateService}
          width="70%"
          onCancel={() => {
            setContentId(0);
            onCloseModalContent();
            setLanguage("vi");
          }}
          footer={[
            <>
              <Button
                size="small"
                onClick={() => {
                  onCloseModalContent();
                }}
              >
                Đóng
              </Button>
              <Button
                size="small"
                className="btn btn-primary"
                type="primary"
                form="CU-tour"
                key="submit"
                htmlType="submit"
                disabled = {!dataChange}
              >
                Hoàn Thành
              </Button>
            </>,
          ]}
        >
          <Row justify="space-around">
            <Col span={24}>
              {contentId != 0 && <Row justify="end" style={{marginBottom: '1.2em'}}>
                <Select
                  onChange={onSelectLanguage}
                  defaultValue="vi"
                  value={language}
                >
                  <Option value="vi">Tiếng Việt</Option>
                  <Option value="en">English</Option>
                  <Option value="fr">French</Option>
                  <Option value="zh-CN">Chinese</Option>
                  <Option value="ko">Korean</Option>
                  <Option value="de">German</Option>
                </Select>
                <Button
                  type="primary"
                  onClick={() => {
                    onHandleTranslate(contentId);
                  }}
                  loading={loadingTranslate}
                >Dịch</Button>
              </Row>}
            </Col>
            <Col span={24}>
              <Form
                {...layout}
                form={formContent}
                name="CU-tour"
                onFinish={onFinishHandleEvent}
                onValuesChange = {onFormValueChange}
              >
                <Form.Item
                  name="title"
                  label="Tiêu đề"
                  rules={[{ required: true }]}
                >
                  <Input size="large" />
                </Form.Item>
                <Form.Item
                  name="slug"
                  label="Slug"
                  rules={[{ required: true }]}
                >
                  <Input size="large" disabled={ language!='vi' } />
                </Form.Item>
                <Form.Item
                  name="content"
                  label="Nội dung"
                >
                  <Input.TextArea rows={4} size="large" />
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Modal>
      </Card>
      <Modal
        visible={openDeleteDialog}
        onOk={deleteContent}
        onCancel={() => {
          setContentId(0);
          setOpenDeleteDialog(false);
        }}
        title={`Xóa nội dung`}
      >
        Bạn có chắc muốn xóa nội dung này?
      </Modal>
    </>
  );
}
